import './events.scss';
import './events-chambre.scss';

function handleListingFilter() {
  const parentContainer = document.getElementById('content');

  if (parentContainer) {
    parentContainer.addEventListener('change', e => {
      if (e.target.closest('.views-exposed-form .form-select')) {
        document.querySelector('.views-exposed-form input[type=submit]').click();
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  handleListingFilter();
});